import { render, staticRenderFns } from "./RequiredInfoForRegi.vue?vue&type=template&id=644537e6&scoped=true&"
import script from "./RequiredInfoForRegi.vue?vue&type=script&lang=js&"
export * from "./RequiredInfoForRegi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644537e6",
  null
  
)

export default component.exports